import { HttpRequest3fsc4149kgwfg as HttpRequest } from './HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpRequestClass;
function DefaultHttpRequest() {
  if (DefaultHttpRequestClass === VOID) {
    class $ {
      constructor(call, data) {
        this.e5x_1 = call;
        this.f5x_1 = data.b5l_1;
        this.g5x_1 = data.a5l_1;
        this.h5x_1 = data.d5l_1;
        this.i5x_1 = data.c5l_1;
        this.j5x_1 = data.f5l_1;
      }
      n5i() {
        return this.e5x_1;
      }
      xv() {
        return this.n5i().xv();
      }
      o5i() {
        return this.f5x_1;
      }
      p5i() {
        return this.g5x_1;
      }
      j2o() {
        return this.h5x_1;
      }
      f50() {
        return this.i5x_1;
      }
      h5i() {
        return this.j5x_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpRequest', VOID, VOID, [HttpRequest()]);
    DefaultHttpRequestClass = $;
  }
  return DefaultHttpRequestClass;
}
//region block: exports
export {
  DefaultHttpRequest as DefaultHttpRequest19v463zllbymg,
};
//endregion

//# sourceMappingURL=DefaultHttpRequest.mjs.map
